import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { MtTask } from "server/models"
import {
    StoreType,
    TasksOnSelect,
    addModal,
} from "client/store"
import {
    TextButton,
    CrossIcon,
    Empty,
    ListWrapper,
    ListItem,
    ListItemTitle,
    DeleteListItemButton,
} from "client/components"

import TaskList from "client/pages/task/list"


interface LinkTasksProps {
    linkedTasks: readonly MtTask[]
    editAccess: boolean
    onAdd: TasksOnSelect
    onDelete: (task: MtTask) => void
}

const LinkTasks = ({
    linkedTasks,
    editAccess,
    onAdd,
    onDelete,
}: LinkTasksProps) => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const addTask = () => {
        dispatch(addModal({
            key: "task",
            content: <TaskList onSelectTasks={onAdd} />,
        }))
    }

    return (
        <ListWrapper>
            {
                linkedTasks.map((task) => (
                    <ListItem key={task.id}>
                        <ListItemTitle>{`#${task.id} - ${task.name}`}</ListItemTitle>
                        {
                            editAccess && (
                                <DeleteListItemButton onClick={() => onDelete(task)}>
                                    <CrossIcon />
                                </DeleteListItemButton>
                            )
                        }
                    </ListItem>
                ))
            }
            {
                !linkedTasks.length
                && <Empty />
            }
            {
                editAccess
                && <TextButton onClick={addTask}>{lang.add}</TextButton>
            }
        </ListWrapper>
    )
}
export default LinkTasks
